import React from 'react';
import { FileText } from 'lucide-react';
interface EvidenceLinkProps {
  href: string;
  title: string;
  label?: string;
}
export function EvidenceLink({
  href,
  title,
  label = 'View regulation extract'
}: EvidenceLinkProps) {
  return <a href={href} target="_blank" rel="noopener noreferrer" title={title} className="inline-flex items-center gap-1.5 text-sm font-medium text-forest-green transition hover:underline" data-id="element-2518" data-mp="3rhscf2sor2cg">
      <FileText className="h-4 w-4" data-id="element-2519" data-mp="5b3u1vm9wa1b" />
      {label}
    </a>;
}